import { BrowserRouter, Route, Routes } from "react-router";
import Layout from "../../layout/Layout";
import Browse, { FilterCategory } from "../browse/Browse";
import Detail from "../detail/Detail";
import Error from "../error/Error";
import Home from "../home/Home";
import { routes } from "./utils";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path={routes.browse.index} element={<Browse />} />
          <Route
            path={routes.browse.detail.people}
            element={<Detail category={FilterCategory.People} />}
          />
          <Route
            path={routes.browse.detail.places}
            element={<Detail category={FilterCategory.Places} />}
          />
          <Route
            path={routes.browse.detail.objects}
            element={<Detail category={FilterCategory.Objects} />}
          />
          <Route
            path={routes.browse.detail.groups}
            element={<Detail category={FilterCategory.Groups} />}
          />
          <Route
            path={routes.browse.detail.events}
            element={<Detail category={FilterCategory.Events} />}
          />
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
